export default "__VITE_ASSET__CT6x9esd__"